import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { IconHighlightModule } from '@portal-core/ui/icons/directives/icon-highlight/icon-highlight.module';
import { HelpIconButtonComponent } from './help-icon-button.component';

@NgModule({
  declarations: [
    HelpIconButtonComponent
  ],
  imports: [
    CommonModule,
    IconHighlightModule,
    MatIconModule,
    MatMenuModule
  ],
  exports: [
    HelpIconButtonComponent
  ]
})
export class HelpIconButtonModule { }
